const ImageIcon = ({ color = '#141B34', height = '24px', width = '24px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height} color={color} fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.5 22.25H4.5C2.98 22.25 1.75 21.02 1.75 19.5V4.5C1.75 2.98 2.98 1.75 4.5 1.75H19.5C21.02 1.75 22.25 2.98 22.25 4.5V19.5C22.25 21.02 21.02 22.25 19.5 22.25ZM4.5 3.25C3.81 3.25 3.25 3.81 3.25 4.5V19.5C3.25 20.19 3.81 20.75 4.5 20.75H5.21085L13.85 12.9797C14.79 12.1397 16.18 12.0397 17.22 12.7297L20.75 15.083V4.5C20.75 3.81 20.19 3.25 19.5 3.25H4.5ZM20.75 16.8864V19.5C20.75 20.19 20.19 20.75 19.5 20.75H7.46342L14.86 14.0897C15.29 13.7097 15.92 13.6597 16.39 13.9797L20.75 16.8864ZM8 10.25C6.76 10.25 5.75 9.24 5.75 8C5.75 6.76 6.76 5.75 8 5.75C9.24 5.75 10.25 6.76 10.25 8C10.25 9.24 9.24 10.25 8 10.25ZM8 7.25C7.59 7.25 7.25 7.59 7.25 8C7.25 8.41 7.59 8.75 8 8.75C8.41 8.75 8.75 8.41 8.75 8C8.75 7.59 8.41 7.25 8 7.25Z"
				fill={color}
			/>
		</svg>
	);
};

export default ImageIcon;
